/**
 * Workflow trigger commands, as opposed to something a person typed.
 *
 * The step panels drive the backend by sending messages like
 * `RUN_MEDIA_PLAN_SCENARIOS\nSession ID: …`. AgentWorkspace echoed whatever it
 * sent into the transcript as a user message, so that command rendered as a
 * full-width block at the top of the Scenarios step — several lines of machine
 * addressing, occupying the space the scenarios themselves needed.
 *
 * A person's own words still echo; only the machine's do not.
 */
const TRIGGER = /^(RUN|SAVE|APPROVE)_[A-Z0-9_]+/;

export const isTriggerCommand = (text: string): boolean =>
  TRIGGER.test((text ?? '').trim());

/**
 * The Step 7 trigger that GENERATES the campaign files.
 *
 * Without a `User Message` the campaign manager only returns a preview and
 * writes no files, so "Generate and Upload" then uploaded nothing ("No SDF
 * files found"). The advertiser rides along so the SDF CSVs name the same
 * advertiser the upload targets.
 */
export const campaignManagerGenerateTrigger = (
  sessionId: string,
  options: { advertiserId?: string; googleAdsCustomerId?: string; mode?: string } = {},
): string => {
  const lines = ['RUN_CAMPAIGN_MANAGER', `Session ID: ${sessionId}`];
  if (options.advertiserId) lines.push(`Advertiser ID: ${options.advertiserId}`);
  if (options.googleAdsCustomerId) lines.push(`Google Ads Customer ID: ${options.googleAdsCustomerId}`);
  if (options.mode) lines.push(`Mode: ${options.mode}`);
  lines.push('User Message: Execute');
  return lines.join('\n');
};

/** A link to a generated file, which needs the bearer token to download. */
export const isProtectedDownloadHref = (href: string | undefined): boolean =>
  /^\/download-file\?/.test(href ?? '');
